<script setup>

import ApexGraph from '@/components/ApexGraph.vue';
import { ref, watch } from 'vue';

const props = defineProps({
    options: {
        type: Object,
        required: true,
    },
});

const chart = ref(props.options);
const addFormatter = (options) => {
    const graph = JSON.parse(JSON.stringify(options));

    const tooltip = graph.tooltip;
    tooltip.x = {
        formatter: function (val, {series, seriesIndex, dataPointIndex, w}) {
            const datum = w.config.series[seriesIndex].data[dataPointIndex];
            return datum.meta.title + ' (' + val + '%)';
        }
    }

    graph.tooltip = tooltip;
    return graph;
}

watch(
    () => props.options,
    (newOptions) => {
        chart.value = addFormatter(newOptions);
    }, {
        immediate: true,
    })

</script>

<template>
    <ApexGraph :options="chart"/>
</template>
